import { useCallback, useMemo, useState } from 'react';
import { LocalStorageUtils } from '@shared/utils';

const DEFAULT_COUNT = 10;

export type ListType =
  | 'accountsPaymentsTransactions' // Accounts > Payments Tab > Transactions && Account > Payment > Transactions
  // | 'accountsCardsTransactions' // Accounts > Cards Tab > Transactions && Accounts > Card > Transactions
  | 'recipients' // Payments > Recipients
  | 'paymentsRequests' // Payments > Payment Requests
  | 'recipientTransactions' // Recipient > Transaction
  | 'reportsPaymentsTransactions' // Reports > Payments Tab > Transactions
  | 'reportsPaymentsAccounts' // Reports > Payments Tab > Accounts Balance
  | 'reportsCardsTransactions' // Reports > Cards Tab > Transactions
  | 'reportsCardsAccounts' // Reports > Cards Tab > Accounts Balance
  | 'statementsConsolidated' // Statements > Cards Tab > Consolidated statement
  | 'statementsAccount' // Statements > Cards Tab > Account statement
  | 'statementsCard' // Statements > Cards Tab > Card statement
  | 'users' // Users
  | 'userCards' // User > Cards
  | 'cardsTransactions' // Cards > Transactions && Card > Transactions && Accounts > Cards Tab > Transactions && Accounts > Card > Transactions
  | 'cards' // Accounts > Cards && Account > Cards && Cards > Cards && Card > Cards
  | 'integration' // Integration
  | 'inquiries'; // Inquiries

interface UseListStateProps {
  list?: ListType;
  count?: number;
}

export const useListState = (props: UseListStateProps = {}) => {
  const [page, setPage] = useState<number>(1);
  const [count, setCount] = useState<number>(() => {
    if (props.list) return LocalStorageUtils.getCountPerPage()[props.list] || props.count || DEFAULT_COUNT;
    return props.count || DEFAULT_COUNT;
  });

  const changePageHandler = useCallback((page: number) => setPage(page), []);
  const changeCountHandler = useCallback(
    (count: number) => {
      setCount(count);
      if (props.list) LocalStorageUtils.setCountPerPage({ [props.list]: count });
    },
    [props.list],
  );

  return useMemo(
    () => ({
      page,
      index: page - 1,
      fromIndex: (page - 1) * count,
      count,
      onChangePage: changePageHandler,
      onChangeCount: changeCountHandler,
    }),
    [count, page, changeCountHandler, changePageHandler],
  );
};
